export default __webpack_public_path__ + "static/media/signup-background.04ade74f.jpg";